__turbopack_context__.v({
  "textLink": "styles-module-scss-module__k4jusq__textLink",
});
